// extracted by mini-css-extract-plugin
module.exports = {"container":"FAQArticle_container__kjbR2","header":"FAQArticle_header__3XwB7","content":"FAQArticle_content__PoxP2"};